/* RESPONSIBLE TEAM: team-proactive-support */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class Prioritization extends Fragment {
  @attr('string') declare attribute: string;
  @attr('string', { defaultValue: 'ascending' }) declare direction: string;
}
